import { AccountRepo } from '@/modules/accounts/app/AccountRepo'
import { query_dispatcher } from "@/api/client"
import { AccountDomain } from '../domain/AccountDomain'

export class ApiAccountRepo implements AccountRepo {

  async findByAccountNumbers(accountNumbers: string[], companyId: string): Promise<AccountDomain[]> {
    
    const queryName = "account.get_accounts"
    const res = await query_dispatcher.dispatch(queryName, {
      accounts: accountNumbers,
      company_id: companyId
    })

    const data = Array.isArray(res) ? res : (res && res.data ? res.data : [])

    return data.map((item: { account: string; description: string }) =>
      AccountDomain.fromPrimitives({
        accountNumber: item.account,
        description: item.description
      })
    )
  }
}
